export const Refund_TYPE= [
    {
        label:'微信支付',
        value:1
    },
    {
        label:'支付宝支付',
        value:2
    },
    {
        label:'微信转账',
        value:3
    },
    {
        label:'支付宝转账',
        value:4
    },
    {
        label:'现金支付',
        value:5
    },
    {
        label:'余额支付',
        value:6
    },
    {
        label:'线下支付',
        value:7
    },
    {
        label:'扫码支付',
        value:8
    }
]
export const Refund_Status= [
    {
        label:'已取消',
        value:1
    },
    {
        label:'申请中',
        value:2
    },
    {
        label:'已拒绝',
        value:3
    },
    {
        label:'退款中',
        value:4
    },
    {
        label:'退款完成',
        value:5
    }
]